var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  Welcome to Smartbooks, enjoy your\n  "),_c('strong',[_vm._v("FREE TRIAL")]),_vm._v(" until\n  "),_c('strong',[_vm._v(_vm._s(_vm._f("dateToHuman")(_vm.eventLog.trialPeriodEnd)))])])}
var staticRenderFns = []

export { render, staticRenderFns }